// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller
/* eslint-disable */

import { application } from "../application"

import AjaxController from '../fudgeball/ajax_controller.js'
application.register('ajax', AjaxController)

import ApplicationController from '../fudgeball/application_controller.js'
application.register('application', ApplicationController)

import ClipboardController from '../fudgeball/clipboard_controller.js'
application.register('clipboard', ClipboardController)

import FormController from '../fudgeball/form_controller.js'
application.register('form', FormController)

import AccordionStepperController from './accordion_stepper_controller.js'
application.register('gimmo-accordion-stepper', AccordionStepperController)

import FeatureTabsController from './feature_tabs_controller.js'
application.register('gimmo-feature-tabs', FeatureTabsController)

import HomeHeroMarqueeController from './home/hero_marquee_controller.js'
application.register('gimmo--home--hero-marquee', HomeHeroMarqueeController)

import HomeHowSplitController from './home/how_split_controller.js'
application.register('gimmo--home--how-split', HomeHowSplitController)

import HomeCurationMarqueeController from './home/curation_marquee_controller.js'
application.register('gimmo--home--curation-marquee', HomeCurationMarqueeController)

import HomeFeatureStackController from './home/feature_stack_controller.js'
application.register('gimmo--home--feature-stack', HomeFeatureStackController)

import HomePrivacyRedactController from './home/privacy_redact_controller.js'
application.register('gimmo--home--privacy-redact', HomePrivacyRedactController)

import HomeTestimonialsCarouselController from './home/testimonials_carousel_controller.js'
application.register('gimmo--home--testimonials-carousel', HomeTestimonialsCarouselController)

import LeadController from './lead_controller.js'
application.register('gimmo--lead', LeadController)

import LocaleDropdownController from './locale_dropdown_controller.js'
application.register('gimmo-locale-dropdown', LocaleDropdownController)

import MobileNavController from './mobile_nav_controller.js'
application.register('gimmo-mobile-nav', MobileNavController)

import OnboardingDescriptionController from './onboarding/description_controller.js'
application.register('gimmo--onboarding--description', OnboardingDescriptionController)

import OnboardingSwipeController from './onboarding/swipe_controller.js'
application.register('gimmo--onboarding--swipe', OnboardingSwipeController)

import OnboardingUsernameController from './onboarding/username_controller.js'
application.register('gimmo--onboarding--username', OnboardingUsernameController)

import PaymentTabsController from './payment_tabs_controller.js'
application.register('gimmo-payment-tabs', PaymentTabsController)

import PhotoPreviewController from './photo_preview_controller.js'
application.register('gimmo-photo-preview', PhotoPreviewController)

import RevealController from './reveal_controller.js'
application.register('gimmo-reveal', RevealController)

import ScreensController from './screens_controller.js'
application.register('gimmo-screens', ScreensController)

import ShareFlashController from './share_flash_controller.js'
application.register('gimmo-share-flash', ShareFlashController)

import SheetModalController from './sheet_modal_controller.js'
application.register('gimmo-sheet-modal', SheetModalController)

import ThankYouRecorderController from './thank_you_recorder_controller.js'
application.register('gimmo-thank-you-recorder', ThankYouRecorderController)

import ThemeToggleController from './theme_toggle_controller.js'
application.register('gimmo-theme-toggle', ThemeToggleController)

import UsernameClaimController from './username_claim_controller.js'
application.register('gimmo-username-claim', UsernameClaimController)

import PagarmeController from '../fudgeball/pagarme_controller.js'
application.register('pagarme', PagarmeController)

import PasswordVisibilityController from './password_visibility_controller.js'
application.register('password-visibility', PasswordVisibilityController)

import TunaController from '../fudgeball/tuna_controller.js'
application.register('tuna', TunaController)

import UtilController from '../fudgeball/util_controller.js'
application.register('util', UtilController)

import ZipcodesController from '../shared/zipcodes_controller.js'
application.register('zipcodes', ZipcodesController)
